import { atom } from "jotai";

import { UpdateMemberRoundInput } from "../../../../../hooks/saveChangesHooks/useSaveChangesToSingleSlotBooking/__generated__/useSaveChangesToSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

export const updatedMemberRoundsAtom = atom<UpdateMemberRoundInput[] | null>(
  (get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const rounds = currentBooking.rounds;
    const memberRounds = rounds?.filter(
      (r) =>
        r.player?.clientType === "member" ||
        r.player?.clientType === "memberHold"
    );
    const input: UpdateMemberRoundInput[] = memberRounds?.map((r) => {
      const rateId = !r.serverId
        ? null
        : r.type === "Golf"
        ? r.roundRate?.id ?? null
        : r.rate?.id ?? null;

      return {
        index: r.index,
        bookingIndex: r.bookingIndex,
        id: r.serverId,
        playerId: r.player?.id || null,
        courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
        transportationTypeId:
          r.type === "Golf" ? r.transportationType?.id : null,
        secondaryTransportationTypeId: r.secondaryTransportationType?.id,
        rateId,
        nonPlayingHost: r.isNonPlayingHost,
      };
    });
    return input;
  }
);
